import { useCollectGuideMutation } from '@http';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button';
import { toast } from 'react-toastify';
import * as Shared from '@shared/lib';
import { useAppStore } from '@stores';

export function Guide() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Guide' });
  const { t: tItems } = useTranslation(undefined, { keyPrefix: 'Items' });
  const { mutateAsync } = useCollectGuideMutation();
  const { userData, isFetching, setIsFetching, refetch } = useAppStore();

  const guideStep = Shared.guideData.find(g => g.id === userData.guideStep);
  if (!guideStep) return null;

  const rewards = Object.entries(guideStep.rewards)
    .map(([key, value]) => `${value}x ${tItems(key)}`)
    .join(', ');
  const canCollect = userData.guideReady;
  const soraUpcoming = 5 - userData.guideStep;
  const myceliaUpcoming = 9 - userData.guideStep;

  const collect = async () => {
    if (isFetching) return;
    setIsFetching(true);

    await mutateAsync();
    refetch();

    toast(t('collectSuccess'), { type: 'success' });
  };

  return (
    <div className="tutorial-guide mb-8 mt-6">
      <div className="flex items-center justify-between mt-4 px-2 mb-1">
        <p className="text-lg">{t('title')}</p>
        {soraUpcoming > 0 && (
          <p className="slight-active text-sm">
            {t('soraUpcoming', { soraUpcoming })}
          </p>
        )}
        {soraUpcoming <= 0 && myceliaUpcoming > 0 && (
          <p className="slight-active text-sm">
            {t('myceliaUpcoming', { myceliaUpcoming })}
          </p>
        )}
      </div>

      <div className="border-y border-secondary bg-black/40 flex justify-between">
        <div className="p-2 flex-1">
          <p className="text-sm">
            {t(`Steps.Step${guideStep.id}.title`)}
          </p>
          <p className="text-xs text-gray-400">
            {t(`Steps.Step${guideStep.id}.description`)}
          </p>

          <p className="text-xs mt-2 slight-active">
            {t('rewards', { rewards })}
          </p>
        </div>

        <Button
          className="btn-active p-0 w-18 border-r-0 border-y-0"
          disabled={!canCollect}
          onClick={collect}
        >
          <div className="flex items-center justify-center w-full h-full">
            <p>{canCollect ? 1 : 0} / 1</p>
          </div>
        </Button>
      </div>
    </div>
  );
}